import { AgCharts } from "ag-charts-react";

type Props = {
  title: string;
  subtitle?: string;
  data: any;
  report?: any;
};

const VerticalBarChart = ({title, subtitle, report}:Props) => {
  const {amount_collected_and_cumulative_amount_per_day:data } = report || {};
  const options: any = {
    title: {
      text: title,
      fontWeight: "bold",
    },
    subtitle: {
      text: subtitle || "",
    },
    data: data,
    height:400,
    series: [
      {
        type: "bar",
        xKey: "day",
        yKey: "collected_amount",
        yName: "Montant collecté",
        fill: "#e33621",
        cornerRadius: 3,
        fillOpacity: "#e33621",
      },
      {
        type: "bar",
        xKey: "day",
        yKey: "cumulative_amount",
        yName: "Montant attendu",
        cornerRadius: 3,
        fill: "#e5e6eb",
        fillOpacity: "#e5e6eb",
      },
    ],
  };

  return <AgCharts options={options} />;
};

export default VerticalBarChart;
